import VideoJS from 'video.js';
import assign from 'lodash/assign';

import * as Controls from '../../ui/UIControlsNames';


const Component = VideoJS.getComponent('Component');


class ASAdClickOverlay extends Component {
    constructor(clickHandler) {
        super(clickHandler);

        this.clickHandler_ = clickHandler;
        this.adClickOverlay_ = this.el().querySelector('.ad-click-overlay-content');

        this.on(this.adClickOverlay_, 'click', this.clickHandler_);
    }

    dispose() {
        super.dispose();
        this.off(this.adClickOverlay_, 'click', this.clickHandler_);
        this.adClickOverlay_ = null;
        this.clickHandler_ = null;
    }

    createEl(_, props, attrs) {
        props = assign({
            innerHTML: this.content(),
            className: 'as-ad-click-overlay'
        }, props);

        return super.createEl('div', props, attrs);
    }

    content() {
        return `<div class="ad-click-overlay-content"></div>`;
    }
}

VideoJS.registerComponent(Controls.AD_CLICK_OVERLAY, ASAdClickOverlay);

export default ASAdClickOverlay;



// WEBPACK FOOTER //
// ./src/player/components/ASAdClickOverlay.js